import React, { createContext, useContext, useMemo, useState } from 'react';

const EduGroupByContext = createContext(null);

export function EduGroupByProvider({ children, initial = 'circuit' }) {
  const [page, setPage] = useState(initial);
  const value = useMemo(() => ({ page, setPage }), [page]);
  return (
    <EduGroupByContext.Provider value={value}>
      {children}
    </EduGroupByContext.Provider>
  );
}

/** Shared group-by page when Provider wraps title charts + table; local state otherwise. */
export function useEduGroupBy(fallbackInitial = 'circuit') {
  const ctx = useContext(EduGroupByContext);
  const [localPage, setLocalPage] = useState(fallbackInitial);
  if (ctx) return ctx;
  return { page: localPage, setPage: setLocalPage };
}

export function useEduGroupByOptional() {
  return useContext(EduGroupByContext);
}
